/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

export enum SectionControlMode {
  Binary = 'Binary',
  Threshold = 'Threshold'
}
